import didiaxios from '@didi/dajax/dist/dajax'
import apiConfig from '@/common/js/apiConfig'

const BASE_URL = apiConfig.hosts.bannerApi
// const BASE_URL = 'https://mock.xiaojukeji.com/mock/776'
const CAPI_URL = apiConfig.hosts.cApi

const REDEEM_URL = BASE_URL + '/act-api/api/code/sidebarRedeem'
const REDEEM_RES_URL = BASE_URL + '/act-api/api/code/redeemResult'
const POP_URL = CAPI_URL + '/common/popDialog'

export const getFallCouponList = function (data) {
  return didiaxios.request({
    url: BASE_URL + '/act-api/api/fallcoupon/couponlist',
    // url: 'https://mock.xiaojukeji.com/mock/776/act-api/api/fallcoupon/couponlist',
    method: 'POST',
    emulateJSON: true,
    needEncrypt: true,
    params: '',
    body: data
  })
}

export const redeemCode = function (data) {
  return didiaxios.request({
    url: REDEEM_URL,
    method: 'POST',
    emulateJSON: true,
    needEncrypt: true,
    params: '',
    body: data
  })
}

export const getRedeemResult = function (data) {
  return didiaxios.request({
    url: REDEEM_RES_URL,
    method: 'POST',
    emulateJSON: true,
    needEncrypt: true,
    params: '',
    body: data
  })
}

export const getPopDialog = function (data) {
  return didiaxios.request({
    url: POP_URL,
    method: 'POST',
    emulateJSON: true,
    needEncrypt: true,
    params: '',
    body: data
  })
}
